import { CONTAINER_BLACK_LIST } from '~/modules/storyblok/constants';

// Checking components that will not be inside the container in Storybook
export const getIsContainer = () => {
  const containerBlackList = new Set(CONTAINER_BLACK_LIST);

  const isContainer = (component: string) => !containerBlackList.has(component);

  return { isContainer };
};
